<template>
  <div>
    <div class="auth">
      <div class="grayHead">
        <span>
          メールアドレスのメールに送信された確認コードを入力してください。
        </span>
      </div>
      <ValidationObserver
        v-slot="{ invalid }"
        ref="observer"
        tag="form"
        name="userLoginForm"
        class="form"
        @submit.prevent="validateBeforeSubmit()"
      >
        <InputText
          v-model="form.authentication_code"
          :vid="'authentication_code'"
          :label="'確認コード'"
          :maxlength="4"
          rules="required|numeric|digits:4"
          class="form__group"
        />

        <!-- Submit Button -->
        <div class="form__group mt72">
          <Btn
            :label="'送信'"
            :color="'red'"
            :disabled="invalid || isLoading"
            :type="'submit'"
          />
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import error from '@/mixin/error.mixin'
import store from '@/store'
import InputText from '@/components/parts/InputText'
import Btn from '@/components/parts/Btn'

export default {
  name: 'MailChangeStep02Code',

  mixins: [
    // APIエラーメッセージ
    error
  ],

  components: {
    InputText,
    Btn
  },

  beforeRouteEnter (from, to, next) {
    if (!store.getters['mailChange/code_request_id']) {
      return next({name: 'MailChangeStep01Mail'})
    }

    const id = from.params['id']
    store.commit('loadingAction', false)

    next(vm => {
      vm.id = id
    })
  },

  data () {
    return {
      id: null,
      form: {
        authentication_code: ''
      }
    }
  },

  computed: {
    ...mapGetters(['isLoading'])
  },

  methods: {
    async validateBeforeSubmit () {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        store.commit('loadingAction', true)
        store.dispatch('mailChange/checkChangeMailCode', {
          id: this.id,
          authentication_code: this.form.authentication_code
        }).then(async () => {
          // 会員情報が変わっているので再取得する
          await store.dispatch('auth/getUser')
          this.$router.push({
            name: 'AccountEditStep01Form'
          }).catch(() => {})
        }).catch((err) => {
          store.commit('loadingAction', false)
          this.addValidateErrors(this.$refs.observer, err)
        })
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
  @import '../../assets/css/form.pcss';
</style>



// WEBPACK FOOTER //
// src/pages/mail-change/Step02Code.vue